import { FC, useEffect } from 'react'
import shallow from 'zustand/shallow'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { useAuth } from '../../context/auth-context'
import useCompanyAndBu from '../../graphql/employee/hooks/useCompanyAndBu'
import { useCollapse } from '../../routes/collapse-context'
import { Country } from '../../types'
import { EmployeeContent } from './EmployeeContent'
import { EmployeeHeader } from './EmployeeHeader'
import { useEmployeeStore } from './EmployeeStore'

export const EmployeesViewContainer: FC = () => {
  const { user } = useAuth()
  const [initStore, storeInitialized] = useEmployeeStore((state) => [state.initStore, state.storeInitialized], shallow)
  const collapsed = useCollapse()

  const { data, error, loading } = useCompanyAndBu(user.employeeId, Country.All)

  useEffect(() => {
    if (
      !!data &&
      !!data.companiesAndBusinessUnitsByEmployee &&
      data.companiesAndBusinessUnitsByEmployee.length &&
      !!data.employeeLevels &&
      data.employeeLevels.length
    ) {
      initStore(data.companiesAndBusinessUnitsByEmployee, data.employeeLevels)
    }
  }, [data, initStore])

  if (
    loading ||
    error ||
    !data ||
    !data.companiesAndBusinessUnitsByEmployee ||
    data.companiesAndBusinessUnitsByEmployee.length === 0 ||
    !data.employeeLevels ||
    data.employeeLevels.length === 0 ||
    ((!!data.companiesAndBusinessUnitsByEmployee.length || !!data.employeeLevels.length) && !storeInitialized)
  ) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors
          isLoading={loading}
          hasNoData={
            !data ||
            !data.companiesAndBusinessUnitsByEmployee ||
            data.companiesAndBusinessUnitsByEmployee.length === 0 ||
            !data.employeeLevels ||
            data.employeeLevels.length === 0
          }
          error={error}
        />
      </ContentContainer>
    )
  } else {
    return (
      <ContentContainer collapsed={collapsed}>
        <EmployeeHeader />
        <EmployeeContent />
      </ContentContainer>
    )
  }
}
